/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Price_Hidden_BadgeInputs */

const cs_property_price_hidden_badge = /** @type {(inputs: Property_Price_Hidden_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena skryta na webu`)
};

const en_property_price_hidden_badge = /** @type {(inputs: Property_Price_Hidden_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price hidden on website`)
};

/**
* | output |
* | --- |
* | "Price hidden on website" |
*
* @param {Property_Price_Hidden_BadgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_price_hidden_badge = /** @type {((inputs?: Property_Price_Hidden_BadgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Price_Hidden_BadgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_price_hidden_badge(inputs)
	return cs_property_price_hidden_badge(inputs)
});